import React from 'react';
import PropTypes from 'prop-types';

const cropZoneActionDefaultPropOnClick = () => {};
const CropZoneAction = ({
  children,
  onClick = cropZoneActionDefaultPropOnClick,
  disabled = false
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="py-2 pl-2 focus:outline-hidden whitespace-nowrap"
    >
      <div className="flex justify-start">{children}</div>
    </button>
  );
};

CropZoneAction.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired
};

export default CropZoneAction;
